"use strict";

require("core-js/stable");

require("regenerator-runtime/runtime");

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

var axios = require('axios');

var TORN_URL = "https://api.torn.com/";

var _key;

var key = function key(_key2) {
  _key = _key2;
};

var url = {
  user: function user() {
    return "".concat(TORN_URL, "user/?key=").concat(_key, "&selections=");
  },
  property: function property() {
    return "".concat(TORN_URL, "property/?key=").concat(_key, "&selections=");
  },
  faction: function faction() {
    return "".concat(TORN_URL, "faction/?key=").concat(_key, "&selections=");
  },
  company: function company() {
    return "".concat(TORN_URL, "company/?key=").concat(_key, "&selections=");
  },
  market: function market() {
    var arg = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    return "".concat(TORN_URL, "market/").concat(arg, "?key=").concat(_key, "&selections=");
  },
  torn: function torn() {
    return "".concat(TORN_URL, "torn/?key=").concat(_key, "&selections=");
  }
};
/**
 * Collection of functions under the user endpoint
 */

var user = {
  /**
   * List all your current ammo
   */
  ammo: function () {
    var _ammo = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return axios.get("".concat(url.user(), "ammo")).then(function (res) {
                return res.data;
              });

            case 2:
              return _context.abrupt("return", _context.sent);

            case 3:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    function ammo() {
      return _ammo.apply(this, arguments);
    }

    return ammo;
  }(),

  /**
   * List all your recent attacks
   */
  attacks: function () {
    var _attacks = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return axios.get("".concat(url.user(), "attacks")).then(function (res) {
                return res.data;
              });

            case 2:
              return _context2.abrupt("return", _context2.sent);

            case 3:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    function attacks() {
      return _attacks.apply(this, arguments);
    }

    return attacks;
  }(),
  attacksfull: function () {
    var _attacksfull = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
      return regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return axios.get("".concat(url.user(), "attacksfull")).then(function (res) {
                return res.data;
              });

            case 2:
              return _context3.abrupt("return", _context3.sent);

            case 3:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));

    function attacksfull() {
      return _attacksfull.apply(this, arguments);
    }

    return attacksfull;
  }(),
  bars: function () {
    var _bars = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
      return regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return axios.get("".concat(url.user(), "bars")).then(function (res) {
                return res.data;
              });

            case 2:
              return _context4.abrupt("return", _context4.sent);

            case 3:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4);
    }));

    function bars() {
      return _bars.apply(this, arguments);
    }

    return bars;
  }(),
  basic: function () {
    var _basic = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
      return regeneratorRuntime.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              _context5.next = 2;
              return axios.get("".concat(url.user(), "basic")).then(function (res) {
                return res.data;
              });

            case 2:
              return _context5.abrupt("return", _context5.sent);

            case 3:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5);
    }));

    function basic() {
      return _basic.apply(this, arguments);
    }

    return basic;
  }(),
  battlestats: function () {
    var _battlestats = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
      return regeneratorRuntime.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              _context6.next = 2;
              return axios.get("".concat(url.user(), "battlestats")).then(function (res) {
                return res.data;
              });

            case 2:
              return _context6.abrupt("return", _context6.sent);

            case 3:
            case "end":
              return _context6.stop();
          }
        }
      }, _callee6);
    }));

    function battlestats() {
      return _battlestats.apply(this, arguments);
    }

    return battlestats;
  }(),
  bazaar: function () {
    var _bazaar = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7() {
      return regeneratorRuntime.wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              _context7.next = 2;
              return axios.get("".concat(url.user(), "bazaar")).then(function (res) {
                return res.data;
              });

            case 2:
              return _context7.abrupt("return", _context7.sent);

            case 3:
            case "end":
              return _context7.stop();
          }
        }
      }, _callee7);
    }));

    function bazaar() {
      return _bazaar.apply(this, arguments);
    }

    return bazaar;
  }(),
  cooldowns: function () {
    var _cooldowns = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8() {
      return regeneratorRuntime.wrap(function _callee8$(_context8) {
        while (1) {
          switch (_context8.prev = _context8.next) {
            case 0:
              _context8.next = 2;
              return axios.get("".concat(url.user(), "cooldowns")).then(function (res) {
                return res.data;
              });

            case 2:
              return _context8.abrupt("return", _context8.sent);

            case 3:
            case "end":
              return _context8.stop();
          }
        }
      }, _callee8);
    }));

    function cooldowns() {
      return _cooldowns.apply(this, arguments);
    }

    return cooldowns;
  }(),
  crimes: function () {
    var _crimes = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee9() {
      return regeneratorRuntime.wrap(function _callee9$(_context9) {
        while (1) {
          switch (_context9.prev = _context9.next) {
            case 0:
              _context9.next = 2;
              return axios.get("".concat(url.user(), "crimes")).then(function (res) {
                return res.data;
              });

            case 2:
              return _context9.abrupt("return", _context9.sent);

            case 3:
            case "end":
              return _context9.stop();
          }
        }
      }, _callee9);
    }));

    function crimes() {
      return _crimes.apply(this, arguments);
    }

    return crimes;
  }(),
  discord: function () {
    var _discord = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee10() {
      return regeneratorRuntime.wrap(function _callee10$(_context10) {
        while (1) {
          switch (_context10.prev = _context10.next) {
            case 0:
              _context10.next = 2;
              return axios.get("".concat(url.user(), "discord")).then(function (res) {
                return res.data;
              });

            case 2:
              return _context10.abrupt("return", _context10.sent);

            case 3:
            case "end":
              return _context10.stop();
          }
        }
      }, _callee10);
    }));

    function discord() {
      return _discord.apply(this, arguments);
    }

    return discord;
  }(),
  display: function () {
    var _display = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee11() {
      return regeneratorRuntime.wrap(function _callee11$(_context11) {
        while (1) {
          switch (_context11.prev = _context11.next) {
            case 0:
              _context11.next = 2;
              return axios.get("".concat(url.user(), "display")).then(function (res) {
                return res.data;
              });

            case 2:
              return _context11.abrupt("return", _context11.sent);

            case 3:
            case "end":
              return _context11.stop();
          }
        }
      }, _callee11);
    }));

    function display() {
      return _display.apply(this, arguments);
    }

    return display;
  }(),
  education: function () {
    var _education = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee12() {
      return regeneratorRuntime.wrap(function _callee12$(_context12) {
        while (1) {
          switch (_context12.prev = _context12.next) {
            case 0:
              _context12.next = 2;
              return axios.get("".concat(url.user(), "education")).then(function (res) {
                return res.data;
              });

            case 2:
              return _context12.abrupt("return", _context12.sent);

            case 3:
            case "end":
              return _context12.stop();
          }
        }
      }, _callee12);
    }));

    function education() {
      return _education.apply(this, arguments);
    }

    return education;
  }(),
  events: function () {
    var _events = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee13() {
      return regeneratorRuntime.wrap(function _callee13$(_context13) {
        while (1) {
          switch (_context13.prev = _context13.next) {
            case 0:
              _context13.next = 2;
              return axios.get("".concat(url.user(), "events")).then(function (res) {
                return res.data;
              });

            case 2:
              return _context13.abrupt("return", _context13.sent);

            case 3:
            case "end":
              return _context13.stop();
          }
        }
      }, _callee13);
    }));

    function events() {
      return _events.apply(this, arguments);
    }

    return events;
  }(),
  gym: function () {
    var _gym = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee14() {
      return regeneratorRuntime.wrap(function _callee14$(_context14) {
        while (1) {
          switch (_context14.prev = _context14.next) {
            case 0:
              _context14.next = 2;
              return axios.get("".concat(url.user(), "gym")).then(function (res) {
                return res.data;
              });

            case 2:
              return _context14.abrupt("return", _context14.sent);

            case 3:
            case "end":
              return _context14.stop();
          }
        }
      }, _callee14);
    }));

    function gym() {
      return _gym.apply(this, arguments);
    }

    return gym;
  }(),
  hof: function () {
    var _hof = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee15() {
      return regeneratorRuntime.wrap(function _callee15$(_context15) {
        while (1) {
          switch (_context15.prev = _context15.next) {
            case 0:
              _context15.next = 2;
              return axios.get("".concat(url.user(), "hof")).then(function (res) {
                return res.data;
              });

            case 2:
              return _context15.abrupt("return", _context15.sent);

            case 3:
            case "end":
              return _context15.stop();
          }
        }
      }, _callee15);
    }));

    function hof() {
      return _hof.apply(this, arguments);
    }

    return hof;
  }(),
  honors: function () {
    var _honors = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee16() {
      return regeneratorRuntime.wrap(function _callee16$(_context16) {
        while (1) {
          switch (_context16.prev = _context16.next) {
            case 0:
              _context16.next = 2;
              return axios.get("".concat(url.user(), "honors")).then(function (res) {
                return res.data;
              });

            case 2:
              return _context16.abrupt("return", _context16.sent);

            case 3:
            case "end":
              return _context16.stop();
          }
        }
      }, _callee16);
    }));

    function honors() {
      return _honors.apply(this, arguments);
    }

    return honors;
  }(),
  icons: function () {
    var _icons = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee17() {
      return regeneratorRuntime.wrap(function _callee17$(_context17) {
        while (1) {
          switch (_context17.prev = _context17.next) {
            case 0:
              _context17.next = 2;
              return axios.get("".concat(url.user(), "icons")).then(function (res) {
                return res.data;
              });

            case 2:
              return _context17.abrupt("return", _context17.sent);

            case 3:
            case "end":
              return _context17.stop();
          }
        }
      }, _callee17);
    }));

    function icons() {
      return _icons.apply(this, arguments);
    }

    return icons;
  }(),
  inventory: function () {
    var _inventory = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee18() {
      return regeneratorRuntime.wrap(function _callee18$(_context18) {
        while (1) {
          switch (_context18.prev = _context18.next) {
            case 0:
              _context18.next = 2;
              return axios.get("".concat(url.user(), "inventory")).then(function (res) {
                return res.data;
              });

            case 2:
              return _context18.abrupt("return", _context18.sent);

            case 3:
            case "end":
              return _context18.stop();
          }
        }
      }, _callee18);
    }));

    function inventory() {
      return _inventory.apply(this, arguments);
    }

    return inventory;
  }(),
  jobpoints: function () {
    var _jobpoints = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee19() {
      return regeneratorRuntime.wrap(function _callee19$(_context19) {
        while (1) {
          switch (_context19.prev = _context19.next) {
            case 0:
              _context19.next = 2;
              return axios.get("".concat(url.user(), "jobpoints")).then(function (res) {
                return res.data;
              });

            case 2:
              return _context19.abrupt("return", _context19.sent);

            case 3:
            case "end":
              return _context19.stop();
          }
        }
      }, _callee19);
    }));

    function jobpoints() {
      return _jobpoints.apply(this, arguments);
    }

    return jobpoints;
  }(),
  medals: function () {
    var _medals = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee20() {
      return regeneratorRuntime.wrap(function _callee20$(_context20) {
        while (1) {
          switch (_context20.prev = _context20.next) {
            case 0:
              _context20.next = 2;
              return axios.get("".concat(url.user(), "medals")).then(function (res) {
                return res.data;
              });

            case 2:
              return _context20.abrupt("return", _context20.sent);

            case 3:
            case "end":
              return _context20.stop();
          }
        }
      }, _callee20);
    }));

    function medals() {
      return _medals.apply(this, arguments);
    }

    return medals;
  }(),
  merits: function () {
    var _merits = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee21() {
      return regeneratorRuntime.wrap(function _callee21$(_context21) {
        while (1) {
          switch (_context21.prev = _context21.next) {
            case 0:
              _context21.next = 2;
              return axios.get("".concat(url.user(), "merits")).then(function (res) {
                return res.data;
              });

            case 2:
              return _context21.abrupt("return", _context21.sent);

            case 3:
            case "end":
              return _context21.stop();
          }
        }
      }, _callee21);
    }));

    function merits() {
      return _merits.apply(this, arguments);
    }

    return merits;
  }(),
  messages: function () {
    var _messages = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee22() {
      return regeneratorRuntime.wrap(function _callee22$(_context22) {
        while (1) {
          switch (_context22.prev = _context22.next) {
            case 0:
              _context22.next = 2;
              return axios.get("".concat(url.user(), "messages")).then(function (res) {
                return res.data;
              });

            case 2:
              return _context22.abrupt("return", _context22.sent);

            case 3:
            case "end":
              return _context22.stop();
          }
        }
      }, _callee22);
    }));

    function messages() {
      return _messages.apply(this, arguments);
    }

    return messages;
  }(),
  money: function () {
    var _money = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee23() {
      return regeneratorRuntime.wrap(function _callee23$(_context23) {
        while (1) {
          switch (_context23.prev = _context23.next) {
            case 0:
              _context23.next = 2;
              return axios.get("".concat(url.user(), "money")).then(function (res) {
                return res.data;
              });

            case 2:
              return _context23.abrupt("return", _context23.sent);

            case 3:
            case "end":
              return _context23.stop();
          }
        }
      }, _callee23);
    }));

    function money() {
      return _money.apply(this, arguments);
    }

    return money;
  }(),
  networth: function () {
    var _networth = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee24() {
      return regeneratorRuntime.wrap(function _callee24$(_context24) {
        while (1) {
          switch (_context24.prev = _context24.next) {
            case 0:
              _context24.next = 2;
              return axios.get("".concat(url.user(), "networth")).then(function (res) {
                return res.data;
              });

            case 2:
              return _context24.abrupt("return", _context24.sent);

            case 3:
            case "end":
              return _context24.stop();
          }
        }
      }, _callee24);
    }));

    function networth() {
      return _networth.apply(this, arguments);
    }

    return networth;
  }(),
  notifications: function () {
    var _notifications = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee25() {
      return regeneratorRuntime.wrap(function _callee25$(_context25) {
        while (1) {
          switch (_context25.prev = _context25.next) {
            case 0:
              _context25.next = 2;
              return axios.get("".concat(url.user(), "notifications")).then(function (res) {
                return res.data;
              });

            case 2:
              return _context25.abrupt("return", _context25.sent);

            case 3:
            case "end":
              return _context25.stop();
          }
        }
      }, _callee25);
    }));

    function notifications() {
      return _notifications.apply(this, arguments);
    }

    return notifications;
  }(),
  perks: function () {
    var _perks = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee26() {
      return regeneratorRuntime.wrap(function _callee26$(_context26) {
        while (1) {
          switch (_context26.prev = _context26.next) {
            case 0:
              _context26.next = 2;
              return axios.get("".concat(url.user(), "perks")).then(function (res) {
                return res.data;
              });

            case 2:
              return _context26.abrupt("return", _context26.sent);

            case 3:
            case "end":
              return _context26.stop();
          }
        }
      }, _callee26);
    }));

    function perks() {
      return _perks.apply(this, arguments);
    }

    return perks;
  }(),
  personalstats: function () {
    var _personalstats = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee27() {
      return regeneratorRuntime.wrap(function _callee27$(_context27) {
        while (1) {
          switch (_context27.prev = _context27.next) {
            case 0:
              _context27.next = 2;
              return axios.get("".concat(url.user(), "personalstats")).then(function (res) {
                return res.data;
              });

            case 2:
              return _context27.abrupt("return", _context27.sent);

            case 3:
            case "end":
              return _context27.stop();
          }
        }
      }, _callee27);
    }));

    function personalstats() {
      return _personalstats.apply(this, arguments);
    }

    return personalstats;
  }(),
  profile: function () {
    var _profile = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee28() {
      return regeneratorRuntime.wrap(function _callee28$(_context28) {
        while (1) {
          switch (_context28.prev = _context28.next) {
            case 0:
              _context28.next = 2;
              return axios.get("".concat(url.user(), "profile")).then(function (res) {
                return res.data;
              });

            case 2:
              return _context28.abrupt("return", _context28.sent);

            case 3:
            case "end":
              return _context28.stop();
          }
        }
      }, _callee28);
    }));

    function profile() {
      return _profile.apply(this, arguments);
    }

    return profile;
  }(),
  properties: function () {
    var _properties = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee29() {
      return regeneratorRuntime.wrap(function _callee29$(_context29) {
        while (1) {
          switch (_context29.prev = _context29.next) {
            case 0:
              _context29.next = 2;
              return axios.get("".concat(url.user(), "properties")).then(function (res) {
                return res.data;
              });

            case 2:
              return _context29.abrupt("return", _context29.sent);

            case 3:
            case "end":
              return _context29.stop();
          }
        }
      }, _callee29);
    }));

    function properties() {
      return _properties.apply(this, arguments);
    }

    return properties;
  }(),
  receivedevents: function () {
    var _receivedevents = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee30() {
      return regeneratorRuntime.wrap(function _callee30$(_context30) {
        while (1) {
          switch (_context30.prev = _context30.next) {
            case 0:
              _context30.next = 2;
              return axios.get("".concat(url.user(), "receivedevents")).then(function (res) {
                return res.data;
              });

            case 2:
              return _context30.abrupt("return", _context30.sent);

            case 3:
            case "end":
              return _context30.stop();
          }
        }
      }, _callee30);
    }));

    function receivedevents() {
      return _receivedevents.apply(this, arguments);
    }

    return receivedevents;
  }(),
  refills: function () {
    var _refills = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee31() {
      return regeneratorRuntime.wrap(function _callee31$(_context31) {
        while (1) {
          switch (_context31.prev = _context31.next) {
            case 0:
              _context31.next = 2;
              return axios.get("".concat(url.user(), "refills")).then(function (res) {
                return res.data;
              });

            case 2:
              return _context31.abrupt("return", _context31.sent);

            case 3:
            case "end":
              return _context31.stop();
          }
        }
      }, _callee31);
    }));

    function refills() {
      return _refills.apply(this, arguments);
    }

    return refills;
  }(),
  revives: function () {
    var _revives = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee32() {
      return regeneratorRuntime.wrap(function _callee32$(_context32) {
        while (1) {
          switch (_context32.prev = _context32.next) {
            case 0:
              _context32.next = 2;
              return axios.get("".concat(url.user(), "revives")).then(function (res) {
                return res.data;
              });

            case 2:
              return _context32.abrupt("return", _context32.sent);

            case 3:
            case "end":
              return _context32.stop();
          }
        }
      }, _callee32);
    }));

    function revives() {
      return _revives.apply(this, arguments);
    }

    return revives;
  }(),
  revivesfull: function () {
    var _revivesfull = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee33() {
      return regeneratorRuntime.wrap(function _callee33$(_context33) {
        while (1) {
          switch (_context33.prev = _context33.next) {
            case 0:
              _context33.next = 2;
              return axios.get("".concat(url.user(), "revivesfull")).then(function (res) {
                return res.data;
              });

            case 2:
              return _context33.abrupt("return", _context33.sent);

            case 3:
            case "end":
              return _context33.stop();
          }
        }
      }, _callee33);
    }));

    function revivesfull() {
      return _revivesfull.apply(this, arguments);
    }

    return revivesfull;
  }(),
  stocks: function () {
    var _stocks = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee34() {
      return regeneratorRuntime.wrap(function _callee34$(_context34) {
        while (1) {
          switch (_context34.prev = _context34.next) {
            case 0:
              _context34.next = 2;
              return axios.get("".concat(url.user(), "stocks")).then(function (res) {
                return res.data;
              });

            case 2:
              return _context34.abrupt("return", _context34.sent);

            case 3:
            case "end":
              return _context34.stop();
          }
        }
      }, _callee34);
    }));

    function stocks() {
      return _stocks.apply(this, arguments);
    }

    return stocks;
  }(),
  travel: function () {
    var _travel = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee35() {
      return regeneratorRuntime.wrap(function _callee35$(_context35) {
        while (1) {
          switch (_context35.prev = _context35.next) {
            case 0:
              _context35.next = 2;
              return axios.get("".concat(url.user(), "travel")).then(function (res) {
                return res.data;
              });

            case 2:
              return _context35.abrupt("return", _context35.sent);

            case 3:
            case "end":
              return _context35.stop();
          }
        }
      }, _callee35);
    }));

    function travel() {
      return _travel.apply(this, arguments);
    }

    return travel;
  }(),
  weaponexp: function () {
    var _weaponexp = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee36() {
      return regeneratorRuntime.wrap(function _callee36$(_context36) {
        while (1) {
          switch (_context36.prev = _context36.next) {
            case 0:
              _context36.next = 2;
              return axios.get("".concat(url.user(), "weaponexp")).then(function (res) {
                return res.data;
              });

            case 2:
              return _context36.abrupt("return", _context36.sent);

            case 3:
            case "end":
              return _context36.stop();
          }
        }
      }, _callee36);
    }));

    function weaponexp() {
      return _weaponexp.apply(this, arguments);
    }

    return weaponexp;
  }(),
  workstats: function () {
    var _workstats = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee37() {
      return regeneratorRuntime.wrap(function _callee37$(_context37) {
        while (1) {
          switch (_context37.prev = _context37.next) {
            case 0:
              _context37.next = 2;
              return axios.get("".concat(url.user(), "workstats")).then(function (res) {
                return res.data;
              });

            case 2:
              return _context37.abrupt("return", _context37.sent);

            case 3:
            case "end":
              return _context37.stop();
          }
        }
      }, _callee37);
    }));

    function workstats() {
      return _workstats.apply(this, arguments);
    }

    return workstats;
  }()
};
var properties = {
  property: function () {
    var _property = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee38() {
      return regeneratorRuntime.wrap(function _callee38$(_context38) {
        while (1) {
          switch (_context38.prev = _context38.next) {
            case 0:
              _context38.next = 2;
              return axios.get("".concat(url.property(), "property")).then(function (res) {
                return res.data;
              });

            case 2:
              return _context38.abrupt("return", _context38.sent);

            case 3:
            case "end":
              return _context38.stop();
          }
        }
      }, _callee38);
    }));

    function property() {
      return _property.apply(this, arguments);
    }

    return property;
  }()
};
var faction = {
  applications: function () {
    var _applications = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee39() {
      return regeneratorRuntime.wrap(function _callee39$(_context39) {
        while (1) {
          switch (_context39.prev = _context39.next) {
            case 0:
              _context39.next = 2;
              return axios.get("".concat(url.faction(), "applications")).then(function (res) {
                return res.data;
              });

            case 2:
              return _context39.abrupt("return", _context39.sent);

            case 3:
            case "end":
              return _context39.stop();
          }
        }
      }, _callee39);
    }));

    function applications() {
      return _applications.apply(this, arguments);
    }

    return applications;
  }(),
  armor: function () {
    var _armor = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee40() {
      return regeneratorRuntime.wrap(function _callee40$(_context40) {
        while (1) {
          switch (_context40.prev = _context40.next) {
            case 0:
              _context40.next = 2;
              return axios.get("".concat(url.faction(), "armor")).then(function (res) {
                return res.data;
              });

            case 2:
              return _context40.abrupt("return", _context40.sent);

            case 3:
            case "end":
              return _context40.stop();
          }
        }
      }, _callee40);
    }));

    function armor() {
      return _armor.apply(this, arguments);
    }

    return armor;
  }(),
  armorynews: function () {
    var _armorynews = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee41() {
      return regeneratorRuntime.wrap(function _callee41$(_context41) {
        while (1) {
          switch (_context41.prev = _context41.next) {
            case 0:
              _context41.next = 2;
              return axios.get("".concat(url.faction(), "armorynews")).then(function (res) {
                return res.data;
              });

            case 2:
              return _context41.abrupt("return", _context41.sent);

            case 3:
            case "end":
              return _context41.stop();
          }
        }
      }, _callee41);
    }));

    function armorynews() {
      return _armorynews.apply(this, arguments);
    }

    return armorynews;
  }(),
  armorynewsfull: function () {
    var _armorynewsfull = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee42() {
      return regeneratorRuntime.wrap(function _callee42$(_context42) {
        while (1) {
          switch (_context42.prev = _context42.next) {
            case 0:
              _context42.next = 2;
              return axios.get("".concat(url.faction(), "armorynewsfull")).then(function (res) {
                return res.data;
              });

            case 2:
              return _context42.abrupt("return", _context42.sent);

            case 3:
            case "end":
              return _context42.stop();
          }
        }
      }, _callee42);
    }));

    function armorynewsfull() {
      return _armorynewsfull.apply(this, arguments);
    }

    return armorynewsfull;
  }(),
  attacknews: function () {
    var _attacknews = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee43() {
      return regeneratorRuntime.wrap(function _callee43$(_context43) {
        while (1) {
          switch (_context43.prev = _context43.next) {
            case 0:
              _context43.next = 2;
              return axios.get("".concat(url.faction(), "attacknews")).then(function (res) {
                return res.data;
              });

            case 2:
              return _context43.abrupt("return", _context43.sent);

            case 3:
            case "end":
              return _context43.stop();
          }
        }
      }, _callee43);
    }));

    function attacknews() {
      return _attacknews.apply(this, arguments);
    }

    return attacknews;
  }(),
  attacknewsfull: function () {
    var _attacknewsfull = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee44() {
      return regeneratorRuntime.wrap(function _callee44$(_context44) {
        while (1) {
          switch (_context44.prev = _context44.next) {
            case 0:
              _context44.next = 2;
              return axios.get("".concat(url.faction(), "attacknewsfull")).then(function (res) {
                return res.data;
              });

            case 2:
              return _context44.abrupt("return", _context44.sent);

            case 3:
            case "end":
              return _context44.stop();
          }
        }
      }, _callee44);
    }));

    function attacknewsfull() {
      return _attacknewsfull.apply(this, arguments);
    }

    return attacknewsfull;
  }(),
  attacks: function () {
    var _attacks2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee45() {
      return regeneratorRuntime.wrap(function _callee45$(_context45) {
        while (1) {
          switch (_context45.prev = _context45.next) {
            case 0:
              _context45.next = 2;
              return axios.get("".concat(url.faction(), "attacks")).then(function (res) {
                return res.data;
              });

            case 2:
              return _context45.abrupt("return", _context45.sent);

            case 3:
            case "end":
              return _context45.stop();
          }
        }
      }, _callee45);
    }));

    function attacks() {
      return _attacks2.apply(this, arguments);
    }

    return attacks;
  }(),
  attacksfull: function () {
    var _attacksfull2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee46() {
      return regeneratorRuntime.wrap(function _callee46$(_context46) {
        while (1) {
          switch (_context46.prev = _context46.next) {
            case 0:
              _context46.next = 2;
              return axios.get("".concat(url.faction(), "attacksfull")).then(function (res) {
                return res.data;
              });

            case 2:
              return _context46.abrupt("return", _context46.sent);

            case 3:
            case "end":
              return _context46.stop();
          }
        }
      }, _callee46);
    }));

    function attacksfull() {
      return _attacksfull2.apply(this, arguments);
    }

    return attacksfull;
  }(),
  basic: function () {
    var _basic2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee47() {
      return regeneratorRuntime.wrap(function _callee47$(_context47) {
        while (1) {
          switch (_context47.prev = _context47.next) {
            case 0:
              _context47.next = 2;
              return axios.get("".concat(url.faction(), "basic")).then(function (res) {
                return res.data;
              });

            case 2:
              return _context47.abrupt("return", _context47.sent);

            case 3:
            case "end":
              return _context47.stop();
          }
        }
      }, _callee47);
    }));

    function basic() {
      return _basic2.apply(this, arguments);
    }

    return basic;
  }(),
  boosters: function () {
    var _boosters = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee48() {
      return regeneratorRuntime.wrap(function _callee48$(_context48) {
        while (1) {
          switch (_context48.prev = _context48.next) {
            case 0:
              _context48.next = 2;
              return axios.get("".concat(url.faction(), "boosters")).then(function (res) {
                return res.data;
              });

            case 2:
              return _context48.abrupt("return", _context48.sent);

            case 3:
            case "end":
              return _context48.stop();
          }
        }
      }, _callee48);
    }));

    function boosters() {
      return _boosters.apply(this, arguments);
    }

    return boosters;
  }(),
  cesium: function () {
    var _cesium = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee49() {
      return regeneratorRuntime.wrap(function _callee49$(_context49) {
        while (1) {
          switch (_context49.prev = _context49.next) {
            case 0:
              _context49.next = 2;
              return axios.get("".concat(url.faction(), "cesium")).then(function (res) {
                return res.data;
              });

            case 2:
              return _context49.abrupt("return", _context49.sent);

            case 3:
            case "end":
              return _context49.stop();
          }
        }
      }, _callee49);
    }));

    function cesium() {
      return _cesium.apply(this, arguments);
    }

    return cesium;
  }(),
  chain: function () {
    var _chain = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee50() {
      return regeneratorRuntime.wrap(function _callee50$(_context50) {
        while (1) {
          switch (_context50.prev = _context50.next) {
            case 0:
              _context50.next = 2;
              return axios.get("".concat(url.faction(), "chain")).then(function (res) {
                return res.data;
              });

            case 2:
              return _context50.abrupt("return", _context50.sent);

            case 3:
            case "end":
              return _context50.stop();
          }
        }
      }, _callee50);
    }));

    function chain() {
      return _chain.apply(this, arguments);
    }

    return chain;
  }(),
  chains: function () {
    var _chains = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee51() {
      return regeneratorRuntime.wrap(function _callee51$(_context51) {
        while (1) {
          switch (_context51.prev = _context51.next) {
            case 0:
              _context51.next = 2;
              return axios.get("".concat(url.faction(), "chains")).then(function (res) {
                return res.data;
              });

            case 2:
              return _context51.abrupt("return", _context51.sent);

            case 3:
            case "end":
              return _context51.stop();
          }
        }
      }, _callee51);
    }));

    function chains() {
      return _chains.apply(this, arguments);
    }

    return chains;
  }(),
  contributors: function () {
    var _contributors = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee52() {
      return regeneratorRuntime.wrap(function _callee52$(_context52) {
        while (1) {
          switch (_context52.prev = _context52.next) {
            case 0:
              _context52.next = 2;
              return axios.get("".concat(url.faction(), "contributors")).then(function (res) {
                return res.data;
              });

            case 2:
              return _context52.abrupt("return", _context52.sent);

            case 3:
            case "end":
              return _context52.stop();
          }
        }
      }, _callee52);
    }));

    function contributors() {
      return _contributors.apply(this, arguments);
    }

    return contributors;
  }(),
  crimenews: function () {
    var _crimenews = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee53() {
      return regeneratorRuntime.wrap(function _callee53$(_context53) {
        while (1) {
          switch (_context53.prev = _context53.next) {
            case 0:
              _context53.next = 2;
              return axios.get("".concat(url.faction(), "crimenews")).then(function (res) {
                return res.data;
              });

            case 2:
              return _context53.abrupt("return", _context53.sent);

            case 3:
            case "end":
              return _context53.stop();
          }
        }
      }, _callee53);
    }));

    function crimenews() {
      return _crimenews.apply(this, arguments);
    }

    return crimenews;
  }(),
  crimenewsfull: function () {
    var _crimenewsfull = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee54() {
      return regeneratorRuntime.wrap(function _callee54$(_context54) {
        while (1) {
          switch (_context54.prev = _context54.next) {
            case 0:
              _context54.next = 2;
              return axios.get("".concat(url.faction(), "crimenewsfull")).then(function (res) {
                return res.data;
              });

            case 2:
              return _context54.abrupt("return", _context54.sent);

            case 3:
            case "end":
              return _context54.stop();
          }
        }
      }, _callee54);
    }));

    function crimenewsfull() {
      return _crimenewsfull.apply(this, arguments);
    }

    return crimenewsfull;
  }(),
  crimes: function () {
    var _crimes2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee55() {
      return regeneratorRuntime.wrap(function _callee55$(_context55) {
        while (1) {
          switch (_context55.prev = _context55.next) {
            case 0:
              _context55.next = 2;
              return axios.get("".concat(url.faction(), "crimes")).then(function (res) {
                return res.data;
              });

            case 2:
              return _context55.abrupt("return", _context55.sent);

            case 3:
            case "end":
              return _context55.stop();
          }
        }
      }, _callee55);
    }));

    function crimes() {
      return _crimes2.apply(this, arguments);
    }

    return crimes;
  }(),
  currency: function () {
    var _currency = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee56() {
      return regeneratorRuntime.wrap(function _callee56$(_context56) {
        while (1) {
          switch (_context56.prev = _context56.next) {
            case 0:
              _context56.next = 2;
              return axios.get("".concat(url.faction(), "currency")).then(function (res) {
                return res.data;
              });

            case 2:
              return _context56.abrupt("return", _context56.sent);

            case 3:
            case "end":
              return _context56.stop();
          }
        }
      }, _callee56);
    }));

    function currency() {
      return _currency.apply(this, arguments);
    }

    return currency;
  }(),
  donations: function () {
    var _donations = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee57() {
      return regeneratorRuntime.wrap(function _callee57$(_context57) {
        while (1) {
          switch (_context57.prev = _context57.next) {
            case 0:
              _context57.next = 2;
              return axios.get("".concat(url.faction(), "donations")).then(function (res) {
                return res.data;
              });

            case 2:
              return _context57.abrupt("return", _context57.sent);

            case 3:
            case "end":
              return _context57.stop();
          }
        }
      }, _callee57);
    }));

    function donations() {
      return _donations.apply(this, arguments);
    }

    return donations;
  }(),
  drugs: function () {
    var _drugs = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee58() {
      return regeneratorRuntime.wrap(function _callee58$(_context58) {
        while (1) {
          switch (_context58.prev = _context58.next) {
            case 0:
              _context58.next = 2;
              return axios.get("".concat(url.faction(), "drugs")).then(function (res) {
                return res.data;
              });

            case 2:
              return _context58.abrupt("return", _context58.sent);

            case 3:
            case "end":
              return _context58.stop();
          }
        }
      }, _callee58);
    }));

    function drugs() {
      return _drugs.apply(this, arguments);
    }

    return drugs;
  }(),
  fundsnews: function () {
    var _fundsnews = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee59() {
      return regeneratorRuntime.wrap(function _callee59$(_context59) {
        while (1) {
          switch (_context59.prev = _context59.next) {
            case 0:
              _context59.next = 2;
              return axios.get("".concat(url.faction(), "fundsnews")).then(function (res) {
                return res.data;
              });

            case 2:
              return _context59.abrupt("return", _context59.sent);

            case 3:
            case "end":
              return _context59.stop();
          }
        }
      }, _callee59);
    }));

    function fundsnews() {
      return _fundsnews.apply(this, arguments);
    }

    return fundsnews;
  }(),
  fundsnewsfull: function () {
    var _fundsnewsfull = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee60() {
      return regeneratorRuntime.wrap(function _callee60$(_context60) {
        while (1) {
          switch (_context60.prev = _context60.next) {
            case 0:
              _context60.next = 2;
              return axios.get("".concat(url.faction(), "fundsnewsfull")).then(function (res) {
                return res.data;
              });

            case 2:
              return _context60.abrupt("return", _context60.sent);

            case 3:
            case "end":
              return _context60.stop();
          }
        }
      }, _callee60);
    }));

    function fundsnewsfull() {
      return _fundsnewsfull.apply(this, arguments);
    }

    return fundsnewsfull;
  }(),
  mainnews: function () {
    var _mainnews = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee61() {
      return regeneratorRuntime.wrap(function _callee61$(_context61) {
        while (1) {
          switch (_context61.prev = _context61.next) {
            case 0:
              _context61.next = 2;
              return axios.get("".concat(url.faction(), "mainnews")).then(function (res) {
                return res.data;
              });

            case 2:
              return _context61.abrupt("return", _context61.sent);

            case 3:
            case "end":
              return _context61.stop();
          }
        }
      }, _callee61);
    }));

    function mainnews() {
      return _mainnews.apply(this, arguments);
    }

    return mainnews;
  }(),
  mainnewsfull: function () {
    var _mainnewsfull = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee62() {
      return regeneratorRuntime.wrap(function _callee62$(_context62) {
        while (1) {
          switch (_context62.prev = _context62.next) {
            case 0:
              _context62.next = 2;
              return axios.get("".concat(url.faction(), "mainnewsfull")).then(function (res) {
                return res.data;
              });

            case 2:
              return _context62.abrupt("return", _context62.sent);

            case 3:
            case "end":
              return _context62.stop();
          }
        }
      }, _callee62);
    }));

    function mainnewsfull() {
      return _mainnewsfull.apply(this, arguments);
    }

    return mainnewsfull;
  }(),
  medical: function () {
    var _medical = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee63() {
      return regeneratorRuntime.wrap(function _callee63$(_context63) {
        while (1) {
          switch (_context63.prev = _context63.next) {
            case 0:
              _context63.next = 2;
              return axios.get("".concat(url.faction(), "medical")).then(function (res) {
                return res.data;
              });

            case 2:
              return _context63.abrupt("return", _context63.sent);

            case 3:
            case "end":
              return _context63.stop();
          }
        }
      }, _callee63);
    }));

    function medical() {
      return _medical.apply(this, arguments);
    }

    return medical;
  }(),
  membershipnews: function () {
    var _membershipnews = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee64() {
      return regeneratorRuntime.wrap(function _callee64$(_context64) {
        while (1) {
          switch (_context64.prev = _context64.next) {
            case 0:
              _context64.next = 2;
              return axios.get("".concat(url.faction(), "membershipnews")).then(function (res) {
                return res.data;
              });

            case 2:
              return _context64.abrupt("return", _context64.sent);

            case 3:
            case "end":
              return _context64.stop();
          }
        }
      }, _callee64);
    }));

    function membershipnews() {
      return _membershipnews.apply(this, arguments);
    }

    return membershipnews;
  }(),
  membershipnewsfull: function () {
    var _membershipnewsfull = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee65() {
      return regeneratorRuntime.wrap(function _callee65$(_context65) {
        while (1) {
          switch (_context65.prev = _context65.next) {
            case 0:
              _context65.next = 2;
              return axios.get("".concat(url.faction(), "membershipnewsfull")).then(function (res) {
                return res.data;
              });

            case 2:
              return _context65.abrupt("return", _context65.sent);

            case 3:
            case "end":
              return _context65.stop();
          }
        }
      }, _callee65);
    }));

    function membershipnewsfull() {
      return _membershipnewsfull.apply(this, arguments);
    }

    return membershipnewsfull;
  }(),
  revives: function () {
    var _revives2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee66() {
      return regeneratorRuntime.wrap(function _callee66$(_context66) {
        while (1) {
          switch (_context66.prev = _context66.next) {
            case 0:
              _context66.next = 2;
              return axios.get("".concat(url.faction(), "revives")).then(function (res) {
                return res.data;
              });

            case 2:
              return _context66.abrupt("return", _context66.sent);

            case 3:
            case "end":
              return _context66.stop();
          }
        }
      }, _callee66);
    }));

    function revives() {
      return _revives2.apply(this, arguments);
    }

    return revives;
  }(),
  revivesfull: function () {
    var _revivesfull2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee67() {
      return regeneratorRuntime.wrap(function _callee67$(_context67) {
        while (1) {
          switch (_context67.prev = _context67.next) {
            case 0:
              _context67.next = 2;
              return axios.get("".concat(url.faction(), "revivesfull")).then(function (res) {
                return res.data;
              });

            case 2:
              return _context67.abrupt("return", _context67.sent);

            case 3:
            case "end":
              return _context67.stop();
          }
        }
      }, _callee67);
    }));

    function revivesfull() {
      return _revivesfull2.apply(this, arguments);
    }

    return revivesfull;
  }(),
  stats: function () {
    var _stats = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee68() {
      return regeneratorRuntime.wrap(function _callee68$(_context68) {
        while (1) {
          switch (_context68.prev = _context68.next) {
            case 0:
              _context68.next = 2;
              return axios.get("".concat(url.faction(), "stats")).then(function (res) {
                return res.data;
              });

            case 2:
              return _context68.abrupt("return", _context68.sent);

            case 3:
            case "end":
              return _context68.stop();
          }
        }
      }, _callee68);
    }));

    function stats() {
      return _stats.apply(this, arguments);
    }

    return stats;
  }(),
  temporary: function () {
    var _temporary = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee69() {
      return regeneratorRuntime.wrap(function _callee69$(_context69) {
        while (1) {
          switch (_context69.prev = _context69.next) {
            case 0:
              _context69.next = 2;
              return axios.get("".concat(url.faction(), "temporary")).then(function (res) {
                return res.data;
              });

            case 2:
              return _context69.abrupt("return", _context69.sent);

            case 3:
            case "end":
              return _context69.stop();
          }
        }
      }, _callee69);
    }));

    function temporary() {
      return _temporary.apply(this, arguments);
    }

    return temporary;
  }(),
  territory: function () {
    var _territory = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee70() {
      return regeneratorRuntime.wrap(function _callee70$(_context70) {
        while (1) {
          switch (_context70.prev = _context70.next) {
            case 0:
              _context70.next = 2;
              return axios.get("".concat(url.faction(), "territory")).then(function (res) {
                return res.data;
              });

            case 2:
              return _context70.abrupt("return", _context70.sent);

            case 3:
            case "end":
              return _context70.stop();
          }
        }
      }, _callee70);
    }));

    function territory() {
      return _territory.apply(this, arguments);
    }

    return territory;
  }(),
  timestamp: function () {
    var _timestamp = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee71() {
      return regeneratorRuntime.wrap(function _callee71$(_context71) {
        while (1) {
          switch (_context71.prev = _context71.next) {
            case 0:
              _context71.next = 2;
              return axios.get("".concat(url.faction(), "timestamp")).then(function (res) {
                return res.data;
              });

            case 2:
              return _context71.abrupt("return", _context71.sent);

            case 3:
            case "end":
              return _context71.stop();
          }
        }
      }, _callee71);
    }));

    function timestamp() {
      return _timestamp.apply(this, arguments);
    }

    return timestamp;
  }(),
  upgrades: function () {
    var _upgrades = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee72() {
      return regeneratorRuntime.wrap(function _callee72$(_context72) {
        while (1) {
          switch (_context72.prev = _context72.next) {
            case 0:
              _context72.next = 2;
              return axios.get("".concat(url.faction(), "upgrades")).then(function (res) {
                return res.data;
              });

            case 2:
              return _context72.abrupt("return", _context72.sent);

            case 3:
            case "end":
              return _context72.stop();
          }
        }
      }, _callee72);
    }));

    function upgrades() {
      return _upgrades.apply(this, arguments);
    }

    return upgrades;
  }(),
  weapons: function () {
    var _weapons = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee73() {
      return regeneratorRuntime.wrap(function _callee73$(_context73) {
        while (1) {
          switch (_context73.prev = _context73.next) {
            case 0:
              _context73.next = 2;
              return axios.get("".concat(url.faction(), "weapons")).then(function (res) {
                return res.data;
              });

            case 2:
              return _context73.abrupt("return", _context73.sent);

            case 3:
            case "end":
              return _context73.stop();
          }
        }
      }, _callee73);
    }));

    function weapons() {
      return _weapons.apply(this, arguments);
    }

    return weapons;
  }()
};
var company = {
  applications: function () {
    var _applications2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee74() {
      return regeneratorRuntime.wrap(function _callee74$(_context74) {
        while (1) {
          switch (_context74.prev = _context74.next) {
            case 0:
              _context74.next = 2;
              return axios.get("".concat(url.company(), "applications")).then(function (res) {
                return res.data;
              });

            case 2:
              return _context74.abrupt("return", _context74.sent);

            case 3:
            case "end":
              return _context74.stop();
          }
        }
      }, _callee74);
    }));

    function applications() {
      return _applications2.apply(this, arguments);
    }

    return applications;
  }(),
  detailed: function () {
    var _detailed = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee75() {
      return regeneratorRuntime.wrap(function _callee75$(_context75) {
        while (1) {
          switch (_context75.prev = _context75.next) {
            case 0:
              _context75.next = 2;
              return axios.get("".concat(url.company(), "detailed")).then(function (res) {
                return res.data;
              });

            case 2:
              return _context75.abrupt("return", _context75.sent);

            case 3:
            case "end":
              return _context75.stop();
          }
        }
      }, _callee75);
    }));

    function detailed() {
      return _detailed.apply(this, arguments);
    }

    return detailed;
  }(),
  employees: function () {
    var _employees = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee76() {
      return regeneratorRuntime.wrap(function _callee76$(_context76) {
        while (1) {
          switch (_context76.prev = _context76.next) {
            case 0:
              _context76.next = 2;
              return axios.get("".concat(url.company(), "employees")).then(function (res) {
                return res.data;
              });

            case 2:
              return _context76.abrupt("return", _context76.sent);

            case 3:
            case "end":
              return _context76.stop();
          }
        }
      }, _callee76);
    }));

    function employees() {
      return _employees.apply(this, arguments);
    }

    return employees;
  }(),
  news: function () {
    var _news = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee77() {
      return regeneratorRuntime.wrap(function _callee77$(_context77) {
        while (1) {
          switch (_context77.prev = _context77.next) {
            case 0:
              _context77.next = 2;
              return axios.get("".concat(url.company(), "news")).then(function (res) {
                return res.data;
              });

            case 2:
              return _context77.abrupt("return", _context77.sent);

            case 3:
            case "end":
              return _context77.stop();
          }
        }
      }, _callee77);
    }));

    function news() {
      return _news.apply(this, arguments);
    }

    return news;
  }(),
  newsfull: function () {
    var _newsfull = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee78() {
      return regeneratorRuntime.wrap(function _callee78$(_context78) {
        while (1) {
          switch (_context78.prev = _context78.next) {
            case 0:
              _context78.next = 2;
              return axios.get("".concat(url.company(), "newsfull")).then(function (res) {
                return res.data;
              });

            case 2:
              return _context78.abrupt("return", _context78.sent);

            case 3:
            case "end":
              return _context78.stop();
          }
        }
      }, _callee78);
    }));

    function newsfull() {
      return _newsfull.apply(this, arguments);
    }

    return newsfull;
  }(),
  profile: function () {
    var _profile2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee79() {
      return regeneratorRuntime.wrap(function _callee79$(_context79) {
        while (1) {
          switch (_context79.prev = _context79.next) {
            case 0:
              _context79.next = 2;
              return axios.get("".concat(url.company(), "profile")).then(function (res) {
                return res.data;
              });

            case 2:
              return _context79.abrupt("return", _context79.sent);

            case 3:
            case "end":
              return _context79.stop();
          }
        }
      }, _callee79);
    }));

    function profile() {
      return _profile2.apply(this, arguments);
    }

    return profile;
  }(),
  stock: function () {
    var _stock = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee80() {
      return regeneratorRuntime.wrap(function _callee80$(_context80) {
        while (1) {
          switch (_context80.prev = _context80.next) {
            case 0:
              _context80.next = 2;
              return axios.get("".concat(url.company(), "stock")).then(function (res) {
                return res.data;
              });

            case 2:
              return _context80.abrupt("return", _context80.sent);

            case 3:
            case "end":
              return _context80.stop();
          }
        }
      }, _callee80);
    }));

    function stock() {
      return _stock.apply(this, arguments);
    }

    return stock;
  }()
};
var market = {
  /**
   * List all/selected item users bazaar
   * @param {number} itemId The ID of desiered item
   * @returns {Dict} List of itemId currently for sale in users bazaar
   */
  bazaar: function () {
    var _bazaar2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee81() {
      var itemId,
          _args81 = arguments;
      return regeneratorRuntime.wrap(function _callee81$(_context81) {
        while (1) {
          switch (_context81.prev = _context81.next) {
            case 0:
              itemId = _args81.length > 0 && _args81[0] !== undefined ? _args81[0] : null;
              _context81.next = 3;
              return axios.get("".concat(url.market(itemId), "bazaar")).then(function (res) {
                return res.data;
              });

            case 3:
              return _context81.abrupt("return", _context81.sent);

            case 4:
            case "end":
              return _context81.stop();
          }
        }
      }, _callee81);
    }));

    function bazaar() {
      return _bazaar2.apply(this, arguments);
    }

    return bazaar;
  }(),

  /**
   * List all/selected item in the item market
   * @param {number} itemId The ID of desiered item
   * @returns {Dict} List of itemId currently for sale on the item market
   */
  itemmarket: function () {
    var _itemmarket = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee82() {
      var itemId,
          _args82 = arguments;
      return regeneratorRuntime.wrap(function _callee82$(_context82) {
        while (1) {
          switch (_context82.prev = _context82.next) {
            case 0:
              itemId = _args82.length > 0 && _args82[0] !== undefined ? _args82[0] : null;
              _context82.next = 3;
              return axios.get("".concat(url.market(itemId), "itemmarket")).then(function (res) {
                return res.data;
              });

            case 3:
              return _context82.abrupt("return", _context82.sent);

            case 4:
            case "end":
              return _context82.stop();
          }
        }
      }, _callee82);
    }));

    function itemmarket() {
      return _itemmarket.apply(this, arguments);
    }

    return itemmarket;
  }(),

  /**
   * List all the currently listing on the points market
   */
  pointsmarket: function () {
    var _pointsmarket = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee83() {
      return regeneratorRuntime.wrap(function _callee83$(_context83) {
        while (1) {
          switch (_context83.prev = _context83.next) {
            case 0:
              _context83.next = 2;
              return axios.get("".concat(url.market(), "pointsmarket")).then(function (res) {
                return res.data;
              });

            case 2:
              return _context83.abrupt("return", _context83.sent);

            case 3:
            case "end":
              return _context83.stop();
          }
        }
      }, _callee83);
    }));

    function pointsmarket() {
      return _pointsmarket.apply(this, arguments);
    }

    return pointsmarket;
  }()
};
var torn = {
  ammo: function () {
    var _ammo2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee84() {
      return regeneratorRuntime.wrap(function _callee84$(_context84) {
        while (1) {
          switch (_context84.prev = _context84.next) {
            case 0:
              _context84.next = 2;
              return axios.get("".concat(url.torn(), "ammo")).then(function (res) {
                return res.data;
              });

            case 2:
              return _context84.abrupt("return", _context84.sent);

            case 3:
            case "end":
              return _context84.stop();
          }
        }
      }, _callee84);
    }));

    function ammo() {
      return _ammo2.apply(this, arguments);
    }

    return ammo;
  }(),
  bank: function () {
    var _bank = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee85() {
      return regeneratorRuntime.wrap(function _callee85$(_context85) {
        while (1) {
          switch (_context85.prev = _context85.next) {
            case 0:
              _context85.next = 2;
              return axios.get("".concat(url.torn(), "bank")).then(function (res) {
                return res.data;
              });

            case 2:
              return _context85.abrupt("return", _context85.sent);

            case 3:
            case "end":
              return _context85.stop();
          }
        }
      }, _callee85);
    }));

    function bank() {
      return _bank.apply(this, arguments);
    }

    return bank;
  }(),
  companies: function () {
    var _companies = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee86() {
      return regeneratorRuntime.wrap(function _callee86$(_context86) {
        while (1) {
          switch (_context86.prev = _context86.next) {
            case 0:
              _context86.next = 2;
              return axios.get("".concat(url.torn(), "companies")).then(function (res) {
                return res.data;
              });

            case 2:
              return _context86.abrupt("return", _context86.sent);

            case 3:
            case "end":
              return _context86.stop();
          }
        }
      }, _callee86);
    }));

    function companies() {
      return _companies.apply(this, arguments);
    }

    return companies;
  }(),
  competition: function () {
    var _competition = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee87() {
      return regeneratorRuntime.wrap(function _callee87$(_context87) {
        while (1) {
          switch (_context87.prev = _context87.next) {
            case 0:
              _context87.next = 2;
              return axios.get("".concat(url.torn(), "competition")).then(function (res) {
                return res.data;
              });

            case 2:
              return _context87.abrupt("return", _context87.sent);

            case 3:
            case "end":
              return _context87.stop();
          }
        }
      }, _callee87);
    }));

    function competition() {
      return _competition.apply(this, arguments);
    }

    return competition;
  }(),
  education: function () {
    var _education2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee88() {
      return regeneratorRuntime.wrap(function _callee88$(_context88) {
        while (1) {
          switch (_context88.prev = _context88.next) {
            case 0:
              _context88.next = 2;
              return axios.get("".concat(url.torn(), "education")).then(function (res) {
                return res.data;
              });

            case 2:
              return _context88.abrupt("return", _context88.sent);

            case 3:
            case "end":
              return _context88.stop();
          }
        }
      }, _callee88);
    }));

    function education() {
      return _education2.apply(this, arguments);
    }

    return education;
  }(),
  factiontree: function () {
    var _factiontree = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee89() {
      return regeneratorRuntime.wrap(function _callee89$(_context89) {
        while (1) {
          switch (_context89.prev = _context89.next) {
            case 0:
              _context89.next = 2;
              return axios.get("".concat(url.torn(), "factiontree")).then(function (res) {
                return res.data;
              });

            case 2:
              return _context89.abrupt("return", _context89.sent);

            case 3:
            case "end":
              return _context89.stop();
          }
        }
      }, _callee89);
    }));

    function factiontree() {
      return _factiontree.apply(this, arguments);
    }

    return factiontree;
  }(),
  gyms: function () {
    var _gyms = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee90() {
      return regeneratorRuntime.wrap(function _callee90$(_context90) {
        while (1) {
          switch (_context90.prev = _context90.next) {
            case 0:
              _context90.next = 2;
              return axios.get("".concat(url.torn(), "gyms")).then(function (res) {
                return res.data;
              });

            case 2:
              return _context90.abrupt("return", _context90.sent);

            case 3:
            case "end":
              return _context90.stop();
          }
        }
      }, _callee90);
    }));

    function gyms() {
      return _gyms.apply(this, arguments);
    }

    return gyms;
  }(),
  honors: function () {
    var _honors2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee91() {
      return regeneratorRuntime.wrap(function _callee91$(_context91) {
        while (1) {
          switch (_context91.prev = _context91.next) {
            case 0:
              _context91.next = 2;
              return axios.get("".concat(url.torn(), "honors")).then(function (res) {
                return res.data;
              });

            case 2:
              return _context91.abrupt("return", _context91.sent);

            case 3:
            case "end":
              return _context91.stop();
          }
        }
      }, _callee91);
    }));

    function honors() {
      return _honors2.apply(this, arguments);
    }

    return honors;
  }(),
  items: function () {
    var _items = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee92() {
      return regeneratorRuntime.wrap(function _callee92$(_context92) {
        while (1) {
          switch (_context92.prev = _context92.next) {
            case 0:
              _context92.next = 2;
              return axios.get("".concat(url.torn(), "items")).then(function (res) {
                return res.data;
              });

            case 2:
              return _context92.abrupt("return", _context92.sent);

            case 3:
            case "end":
              return _context92.stop();
          }
        }
      }, _callee92);
    }));

    function items() {
      return _items.apply(this, arguments);
    }

    return items;
  }(),
  medals: function () {
    var _medals2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee93() {
      return regeneratorRuntime.wrap(function _callee93$(_context93) {
        while (1) {
          switch (_context93.prev = _context93.next) {
            case 0:
              _context93.next = 2;
              return axios.get("".concat(url.torn(), "medals")).then(function (res) {
                return res.data;
              });

            case 2:
              return _context93.abrupt("return", _context93.sent);

            case 3:
            case "end":
              return _context93.stop();
          }
        }
      }, _callee93);
    }));

    function medals() {
      return _medals2.apply(this, arguments);
    }

    return medals;
  }(),
  organisedcrimes: function () {
    var _organisedcrimes = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee94() {
      return regeneratorRuntime.wrap(function _callee94$(_context94) {
        while (1) {
          switch (_context94.prev = _context94.next) {
            case 0:
              _context94.next = 2;
              return axios.get("".concat(url.torn(), "organisedcrimes")).then(function (res) {
                return res.data;
              });

            case 2:
              return _context94.abrupt("return", _context94.sent);

            case 3:
            case "end":
              return _context94.stop();
          }
        }
      }, _callee94);
    }));

    function organisedcrimes() {
      return _organisedcrimes.apply(this, arguments);
    }

    return organisedcrimes;
  }(),
  pawnshop: function () {
    var _pawnshop = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee95() {
      return regeneratorRuntime.wrap(function _callee95$(_context95) {
        while (1) {
          switch (_context95.prev = _context95.next) {
            case 0:
              _context95.next = 2;
              return axios.get("".concat(url.torn(), "pawnshop")).then(function (res) {
                return res.data;
              });

            case 2:
              return _context95.abrupt("return", _context95.sent);

            case 3:
            case "end":
              return _context95.stop();
          }
        }
      }, _callee95);
    }));

    function pawnshop() {
      return _pawnshop.apply(this, arguments);
    }

    return pawnshop;
  }(),
  properties: function () {
    var _properties2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee96() {
      return regeneratorRuntime.wrap(function _callee96$(_context96) {
        while (1) {
          switch (_context96.prev = _context96.next) {
            case 0:
              _context96.next = 2;
              return axios.get("".concat(url.torn(), "properties")).then(function (res) {
                return res.data;
              });

            case 2:
              return _context96.abrupt("return", _context96.sent);

            case 3:
            case "end":
              return _context96.stop();
          }
        }
      }, _callee96);
    }));

    function properties() {
      return _properties2.apply(this, arguments);
    }

    return properties;
  }(),
  rackets: function () {
    var _rackets = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee97() {
      return regeneratorRuntime.wrap(function _callee97$(_context97) {
        while (1) {
          switch (_context97.prev = _context97.next) {
            case 0:
              _context97.next = 2;
              return axios.get("".concat(url.torn(), "rackets")).then(function (res) {
                return res.data;
              });

            case 2:
              return _context97.abrupt("return", _context97.sent);

            case 3:
            case "end":
              return _context97.stop();
          }
        }
      }, _callee97);
    }));

    function rackets() {
      return _rackets.apply(this, arguments);
    }

    return rackets;
  }(),
  raids: function () {
    var _raids = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee98() {
      return regeneratorRuntime.wrap(function _callee98$(_context98) {
        while (1) {
          switch (_context98.prev = _context98.next) {
            case 0:
              _context98.next = 2;
              return axios.get("".concat(url.torn(), "raids")).then(function (res) {
                return res.data;
              });

            case 2:
              return _context98.abrupt("return", _context98.sent);

            case 3:
            case "end":
              return _context98.stop();
          }
        }
      }, _callee98);
    }));

    function raids() {
      return _raids.apply(this, arguments);
    }

    return raids;
  }(),
  stats: function () {
    var _stats2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee99() {
      return regeneratorRuntime.wrap(function _callee99$(_context99) {
        while (1) {
          switch (_context99.prev = _context99.next) {
            case 0:
              _context99.next = 2;
              return axios.get("".concat(url.torn(), "stats")).then(function (res) {
                return res.data;
              });

            case 2:
              return _context99.abrupt("return", _context99.sent);

            case 3:
            case "end":
              return _context99.stop();
          }
        }
      }, _callee99);
    }));

    function stats() {
      return _stats2.apply(this, arguments);
    }

    return stats;
  }(),
  stocks: function () {
    var _stocks2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee100() {
      return regeneratorRuntime.wrap(function _callee100$(_context100) {
        while (1) {
          switch (_context100.prev = _context100.next) {
            case 0:
              _context100.next = 2;
              return axios.get("".concat(url.torn(), "stocks")).then(function (res) {
                return res.data;
              });

            case 2:
              return _context100.abrupt("return", _context100.sent);

            case 3:
            case "end":
              return _context100.stop();
          }
        }
      }, _callee100);
    }));

    function stocks() {
      return _stocks2.apply(this, arguments);
    }

    return stocks;
  }(),
  territory: function () {
    var _territory2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee101() {
      return regeneratorRuntime.wrap(function _callee101$(_context101) {
        while (1) {
          switch (_context101.prev = _context101.next) {
            case 0:
              _context101.next = 2;
              return axios.get("".concat(url.torn(), "territory")).then(function (res) {
                return res.data;
              });

            case 2:
              return _context101.abrupt("return", _context101.sent);

            case 3:
            case "end":
              return _context101.stop();
          }
        }
      }, _callee101);
    }));

    function territory() {
      return _territory2.apply(this, arguments);
    }

    return territory;
  }(),
  territorywars: function () {
    var _territorywars = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee102() {
      return regeneratorRuntime.wrap(function _callee102$(_context102) {
        while (1) {
          switch (_context102.prev = _context102.next) {
            case 0:
              _context102.next = 2;
              return axios.get("".concat(url.torn(), "territorywars")).then(function (res) {
                return res.data;
              });

            case 2:
              return _context102.abrupt("return", _context102.sent);

            case 3:
            case "end":
              return _context102.stop();
          }
        }
      }, _callee102);
    }));

    function territorywars() {
      return _territorywars.apply(this, arguments);
    }

    return territorywars;
  }()
};
module.exports = {
  key: key,
  user: user,
  properties: properties,
  faction: faction,
  company: company,
  market: market,
  torn: torn
};